import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'dados',
            props: (route) => ({ ...route.query }),
            meta: { title: 'Home' },
            component: () => import(/* webpackChunkName: "dados" */ '@/views/Dados.vue'),
        },
        {
            path: '/complemento',
            name: 'complemento',
            meta: { title: 'Complemento' },
            component: () => import(/* webpackChunkName: "complemento" */ '@/views/Complemento.vue'),
        },
        {
            path: '/detalhes',
            name: 'detalhes',
            meta: { title: 'Proposta' },
            component: () => import(/* webpackChunkName: "detalhes" */ '@/views/Detalhes.vue'),
        },
        {
            path: '/resumo',
            name: 'resumo',
            meta: { title: 'Resumo' },
            component: () => import(/* webpackChunkName: "resumo" */ '@/views/Resumo.vue'),
        },
        {
            path: '/finalizar',
            name: 'finalizar',
            meta: { title: 'Finalizar' },
            component: () => import(/* webpackChunkName: "finalizar" */ '@/views/Finalizar.vue'),
        },
        {
            path: '/sequencia',
            name: 'sequencia',
            meta: { title: 'Sequência' },
            component: () => import(/* webpackChunkName: "complemento" */ '@/views/SequenciaComplemento.vue'),
        },
        {
            path: '/endereco',
            name: 'endereco',
            meta: { title: 'Endereço' },
            component: () => import(/* webpackChunkName: "complemento" */ '@/views/Endereco.vue'),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }

});
